import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get('hesa-detail/types')
}
